import React from 'react';

const Header = () => {
  return <wp-header></wp-header>;
};

export default Header;
